<div class="shared-debtor-search-modal">
  @if (useQuotesDebtorStore) {
    <app-shared-debtor-search
      (stockItemsSelected)="handleSelectedItems($event)"
      [confirmOnRowClick]="false"
      [gridColDefs]="gridColDefs()"
      [gridOptions]="gridOptions"
      [multiple]="false"
      [requireSelection]="requireSelection"
      [setDebtorsLoading]="(isDebtorsLoading$ | ngrxPush) ?? false"
      [setStockData]="debtors$ | ngrxPush"
      [title]="title">
    </app-shared-debtor-search>
  } @else {
    <app-shared-debtor-search
      (stockItemsSelected)="handleSelectedItems($event)"
      [confirmOnRowClick]="false"
      [gridColDefs]="gridColDefs()"
      [gridOptions]="gridOptions"
      [multiple]="false"
      [requireSelection]="requireSelection"
      [setDebtorsLoading]="isLoading"
      [setStockData]="debtors"
      [title]="title">
    </app-shared-debtor-search>
  }
</div>
